const GEOGRAPHICAL_TYPE = {
    "RURAL": "Rural",
    "URBAN": "Urban",
};

const ACCENT = {
    "EN_US": "English US",
    "EN_IN": "English India",
    "EN_UK": "English UK"
}
const WORDS_PER_MIN = [60, 80, 90]

const GENDER = {
    "Male": 'Male',
    "Female": 'Female'
}

const LEARNING_GENERATION = [1, 2, 3]

const DEFAULT_SPEECH_CONFIG = {
    geographicalType: "URBAN",
    learningGeneration: 2,
    accent: 'EN_IN',
    gender: 'Female',
    words_per_minute: 80,
};

const SAMPLE_SENTENCES = [
    "Hello! Let's learn something fun today.",
    "Can you count to ten? One, two, three, four, five!",
    "The sun is bright, and the sky is blue.",
    "My name is Arya, and I love to play games.",
    "Red apples are sweet, and green apples are sour."
];

export const speechConstant = {
    GEOGRAPHICAL_TYPE,
    ACCENT,
    WORDS_PER_MIN,
    GENDER,
    LEARNING_GENERATION,
    DEFAULT_SPEECH_CONFIG,
    SAMPLE_SENTENCES

}